import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Select, Typography, DatePicker, Modal, Col, Row, Statistic } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment';
import logo from '../../../../assets/images/vtrc-logo.png'
import { Mutations } from '../../../../graphql'
import { message } from 'antd'
import { setToken, isLoggedIn, getLsId, checkLinkURL } from '../../../../utils/auth'
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";
import { UniqueFieldDefinitionNamesRule } from 'graphql';
import iconsLine from '../../../../assets/images/icons/line-news.png'
import OtpInput from 'react-otp-input';

const { Option } = Select;
const { Text, Title } = Typography
const { Countdown } = Statistic;

const { RangePicker } = DatePicker
const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
};
const nowyear = new Date().getFullYear() + 543 - 10;

const optionsmonth = [
	{ value: "1", name: 'มกราคม' },
	{ value: "2", name: 'กุมภาพันธ์' },
	{ value: "3", name: 'มีนาคม' },
	{ value: "4", name: 'เมษายน' },
	{ value: "5", name: 'พฤษภาคม' },
	{ value: "6", name: 'มิถุนายน' },
	{ value: "7", name: 'กรกฎาคม' },
	{ value: "8", name: 'สิงหาคม' },
	{ value: "9", name: 'กันยายน' },
	{ value: "10", name: 'ตุลาคม' },
	{ value: "11", name: 'พฤศจิกายน' },
	{ value: "12", name: 'ธันวาคม' },
];

let optionsyear = [];

class ConfirmUser extends React.PureComponent {
	state = {
		employeeCode: sessionStorage.getItem('username'),
		dataday: [{ date: 1 }],
		totalday: 31,
		selectday: "1",
		selectmonth: "1",
		selectyear: nowyear,
		inputCitizen: null,
		showError: false,
		deadline: Date.now() + 1000 * 300,
		otp: '',
		setOtp: '',
		checkCounToClickOtp: 0,
      otpToSeadPage:{
         otpToken: null,
         refCode: null
      }
	}
	cancle() {
		sessionStorage.clear()
		localStorage.clear()
		window.location.href = '/login'
	}

	handleSubmit = async e => {
		console.log("yes");
		const { form } = this.props
		e.preventDefault()
		form.validateFields(async (err, values) => {
				this.setState({
					showError:false
				})
				if (!err) {
					const DataFetchAPI = await axiosAPI.post(
						`
						   ${checkLinkURL()}SSOService/verify/otp`,
						   {
								otpToken: this.state.otpToSeadPage.otpToken ? this.state.otpToSeadPage.otpToken : this.props.otpToSead.otpData.otpToken,
								refCode: this.state.otpToSeadPage.refCode ? this.state.otpToSeadPage.refCode : this.props.otpToSead.otpData.refCode,
								otpCode: this.state.otp,
						   },
					);

					console.log("DataFetchAPI otpConfirme", DataFetchAPI)


					if(DataFetchAPI.data.success){
                  // if(this.props.dataProfileSSO.isChula){
                     this.props.switchShowPage(this.props.dataProfileSSO.isChula ? 4 : 3, this.props.otpToSead)
                  // }else{
                     
                  // }
					}else{
						message.error(DataFetchAPI.data.message)
					}
					// otpToken = ที่ได้จาก API - 2
					// refCode = ที่ได้จาก API - 2
					// otpCode = otp ที่กรอก
				}
		})
	}

	componentDidMount = async () => {
		let year = nowyear
		for (let index = 0; index < 120; index++) {
			optionsyear[index] = { value: year, name: year };
			year = year - 1
		}

		let day = moment(this.state.selectyear + '-01', 'YYYY-MM').daysInMonth()
		await this.setState({ totalday: day })
		this.functotalday()

	}

	functotalday = async () => {
		let day = [{ date: 1 }]
		for (let index = 1; index <= this.state.totalday; index++) {
			day[index - 1] = { date: index }
		}
		if (this.state.totalday < this.state.selectday) {
			await this.setState({ selectday: "1" })
		}
		await this.setState({ dataday: day })
	}

	changeday = async (value) => {
		await this.setState({ selectday: value })

	}

	changemonth = async (value) => {
		await this.setState({ selectmonth: value })
		let day = moment(this.state.selectyear + '-0' + this.state.selectmonth, 'YYYY-MM').daysInMonth()

		if (this.state.totalday != day) {
			await this.setState({ totalday: day })
			this.functotalday()
		}
	}

	changeyear = async (value) => {
		await this.setState({ selectyear: value })
		let day = moment(this.state.selectyear + '-0' + this.state.selectmonth, 'YYYY-MM').daysInMonth()

		if (this.state.totalday != day) {
			await this.setState({ totalday: day })
			this.functotalday()
		}
	}

	onChangeInputNumber = async (e) =>{
		const financialGoal = (e.target.validity.valid) ? e.target.value : this.state.inputCitizen;
        await this.setState({ inputCitizen: financialGoal })
	}

	handleOTPChange = (otp) => {
		// setConfig((prevConfig) => ({ ...prevConfig, otp }));
		this.setState({ 
			setOtp: otp,
			otp
		})
	};

	resendOTP = async() =>{
		const DataFetchAPI = await axiosAPI.post(
			`
			   ${checkLinkURL()}SSOService/verify`,
			   {
					idCard: this.props.otpToSead.citizenId,
					birthDate: this.props.otpToSead.birthDate,
               ssoId: this.props.dataProfileSSO.ssoId
			   },
		);

      console.log("DataFetchAPI", DataFetchAPI)
		
      if(DataFetchAPI.data.success){
         await this.setState({
            deadline: Date.now() + 1000 * 300,
            checkCounToClickOtp: this.state.checkCounToClickOtp+1,
            otpToSeadPage:{
               otpToken: DataFetchAPI.data.data.otpToken,
               refCode: DataFetchAPI.data.data.refCode
            }
         })
      }else{
         message.error(DataFetchAPI.data.message)
      }
		
	}

	onFinishCountOTP = async () => {
        await this.setState({ 
			checkCounToClickOtp: 1
		})
    }

	render() {
		const { selectday, selectmonth, selectyear, dataday, otp, setOtp } = this.state
		const { form, otpToSead } = this.props
		const { getFieldDecorator } = form

		return (
         <>
            <Form>

               <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
                  <img src={logo} alt="logo" className="logo-formlogin"  />

               </div>
               <div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>
                  <Title level={3} style={{ marginBottom: '0' }}>กรุณากรอกรหัส OTP</Title>
				  <span>ระบบได้ทำการส่ง OTP สำหรับใช้ครั้งเดียว <br></br>
              ไปที่หมายเลขโทรศัพท์ { this.props.otpToSead.otpData.sendTo }</span>
                  {/* <b type="secondary">ยืนยันตัวตนของคุณ</b> */}
               </div>
			   	<Row gutter={16} type="flex" justify="left" align="top" className="py-2">
					<Col md={12} className="">
						<Title level={4} style={{ marginBottom: '0' }}>รหัส OTP</Title>
					</Col>
					<Col md={12} className="" align="right">
                  <span>เลขที่อ้างอิง : {  this.state.otpToSeadPage.refCode ? this.state.otpToSeadPage.refCode : this.props.otpToSead.otpData.refCode}</span>
					</Col>
					<Col md={24} className="mt-2" align="center">
						<Form.Item label="" colon={false} name="otp" style={{ marginBottom: '0' }}>
							<OtpInput
								inputStyle="inputStyle"
								value={otp}
								onChange={this.handleOTPChange}
								numInputs={6}
								renderSeparator={<span> </span>}
								renderInput={(props) => <input {...props} />}
							/>
						</Form.Item>
					</Col>
					<Col md={24} className="mt-2" align="right">
						<span>
							OTP จะหมดอายุภายใน 
							<Countdown 
								className="mt-1 pl-2 mr-2" 
								valueStyle={{ fontSize: "14px" }} 
								value={this.state.deadline} 
								format="mm:ss"  
								style={{ display:"inline-block"}} 
								onFinish={this.onFinishCountOTP}
							/> 
								นาที
							</span>
						{/* <span>OTP จะหมดอายุภายใน 3 นาที</span> */}
					</Col>
					<Col md={24} className="mt-5" align="center">
						<span 
							style =	{{ 
										cursor: this.state.checkCounToClickOtp !== 3 ? "pointer" : "no-drop",
									}}
							onClick={() => this.state.checkCounToClickOtp !== 3 ? this.resendOTP() : ""}
						>
							<Icon type="sync" className='mr-3'/>
							ส่งรหัส OTP อีกครั้ง
						</span><br></br>
						{
							this.state.checkCounToClickOtp == 3 &&
								<span style={{ color: "#d7222a", fontSize: "13px" }}>
									มีการร้องขอมากเกินไป โปรดรอจนกว่าเวลาจะรีเซ็ตและทำการลองอีกครั้ง
								</span>
						}
						
					</Col>
				</Row>
               
               <Form.Item style={{ textAlign: 'center', marginBottom: 30}} className='mt-3'>
                  <Button className='mr-md-1' type="primary btn-color-transparent btn-custom btn-cutom-width mb-2" htmlType="submit" onClick={this.handleSubmit} >
				  ยืนยัน OTP
                  </Button>
               </Form.Item>
            </Form>

            {/* <table>
               <tr>
                  <td>
                     <div className="ml-1">
                        <Icon type="file-text" />
                     </div>
                  </td>
                  <td style={{ verticalAlign:"top" }} className="pl-3">
                     <p className="mb-1 pt-1">
                        คำถามเกี่ยวกับรหัสบุคลากร
                     </p>
                  </td>
               </tr>
               <tr>
                  <td style={{ verticalAlign:"top" }}>
                     <div className="ml-1">
                        <Icon type="phone" rotate={90} />
                     </div>
                  </td>
                  <td style={{ verticalAlign:"top" }} className="pl-3">
                     <a style={{ color:"#595959" }} href="mailto:callcenter@vtrcsupport.com">
                     หากมีข้อสงสัย/แจ้งปัญหาการใช้งานสามารถติดต่อ<br></br>
                     ได้ที่ Callcenter@vtrcsupport.com
                     </a>
                  </td>
               </tr>
               <tr>
                  <td style={{ verticalAlign:"top" }}>
                     <div>
                        <img src={iconsLine} style={{ maxWidth: '24px', height: 'auto' }} />
                     </div>
                  </td>
                  <td style={{ verticalAlign:"top" }} className="pl-3">
                     <p className="mb-1 pt-1">
                        คำถามเกี่ยวกับรหัสบุคลากร
                     </p>
                  </td>
               </tr>
            </table> */}
         </>
		)
	}
}

ConfirmUser.defaultProps = {
	autoFocus: false
}

ConfirmUser.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedConfirmUser = Form.create()(ConfirmUser)

export default WrappedConfirmUser
